var _rect, _rect2, _rect3, _g, _circle;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDealLayoutB1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 17,
    viewBox: "0 0 23 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.75,
    y: 0.75,
    width: 21.5,
    height: 11.5,
    rx: 1.25,
    stroke: "current",
    strokeWidth: 1.5
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 15,
    width: 21,
    height: 1,
    rx: 0.5,
    stroke: "current",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_11577_9860",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 1,
    width: 23,
    height: 12
  }, _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    y: 1,
    width: 22.8,
    height: 12,
    rx: 2,
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_11577_9860)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.931513 12.0326C0.698543 12.1809 0.629866 12.4899 0.77812 12.7229C0.926374 12.9559 1.23542 13.0246 1.46839 12.8763L0.931513 12.0326ZM7.19995 8.63629L7.44696 8.20156L7.18535 8.05292L6.93151 8.21446L7.19995 8.63629ZM12 11.3636L11.7529 11.7983L12.0366 11.9594L12.2984 11.7647L12 11.3636ZM18.6 6.45447L18.8757 6.03739L18.5831 5.84389L18.3015 6.05328L18.6 6.45447ZM1.46839 12.8763L7.46839 9.05812L6.93151 8.21446L0.931513 12.0326L1.46839 12.8763ZM6.95295 9.07101L11.7529 11.7983L12.247 10.9288L7.44696 8.20156L6.95295 9.07101ZM12.2984 11.7647L18.8984 6.85566L18.3015 6.05328L11.7015 10.9624L12.2984 11.7647ZM18.3242 6.87155L24.9242 11.2352L25.4757 10.401L18.8757 6.03739L18.3242 6.87155Z",
    fill: "current"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 4,
    r: 1,
    stroke: "current",
    strokeWidth: 0.8
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDealLayoutB1);
export default __webpack_public_path__ + "static/media/DealLayoutB_1.ad800eed0db78ae9c7df1e44fc7ef5be.svg";
export { ForwardRef as ReactComponent };